import React, { useEffect, useState } from 'react';
import IconoEstadoCita from './IconoEstadoCita';
import { getCitas } from '../../services/citaService';
import {
  HORA_INICIO, HORA_FIN, PX_HORA, ALTURA_MINIMA_CITA, citasDelDia, mismaFecha,
  distribuirCitas, posicionCita, colorFondoCita, colorBordeCita
} from '../../utils/distribucionCitas';
import '../../styles/CalendarioDistribucion.css';

const HORAS = Array.from({ length: HORA_FIN - HORA_INICIO }, (_, i) => HORA_INICIO + i);

export default function VistaDiaria({ fecha, profesional, refrescar, onSelectCita, onNuevaCita }) {
  const [citas, setCitas] = useState([]);

  useEffect(() => {
    let activo = true;
    getCitas({
      profesional,
      from: fecha.toISOString().slice(0, 10),
      to: fecha.toISOString().slice(0, 10)
    }).then(datos => { if (activo) setCitas(datos); })
      .catch(err => console.error('Error cargando citas:', err));
    return () => { activo = false; };
  }, [fecha, profesional, refrescar]);

  const ahora = new Date();
  const esHoy = mismaFecha(ahora, fecha);
  const topHoraActual = ((ahora.getHours() - HORA_INICIO) * 60 + ahora.getMinutes()) * PX_HORA / 60;

  function pintarCitasDia() {
    const delDia = citasDelDia(citas.filter(c => profesional === 'ALL' || c.profesional === profesional), fecha);
    return distribuirCitas(delDia).flatMap(grupo => grupo.eventos.map(item => {
      const { cita } = item;
      const height = Math.max(ALTURA_MINIMA_CITA, (item.end - item.start) * PX_HORA / 60);
      return (
        <button key={cita.id} type="button" className="cita cita-diaria cita-cal-button"
          title={`${cita.paciente || ''} — ${cita.tratamiento || ''}`}
          data-tooltip={`${cita.paciente || ''}\n${cita.tratamiento || ''}`}
          style={{
            ...posicionCita(item, grupo.columnas),
            borderLeft: `4px solid ${colorBordeCita(cita)}`,
            background: colorFondoCita(cita)
          }}
          onClick={() => onSelectCita(cita)}>
          <span className="cita-contenido">
            <strong className="cita-nombre"><IconoEstadoCita estado={cita.estadoAviso} /><span className="cita-nombre-texto">{cita.paciente}</span></strong>
            {height >= 34 && <span className="cita-tratamiento">{cita.tratamiento}</span>}
          </span>
        </button>
      );
    }));
  }

  return (
    <div className="agenda">
      <div className="agenda-grid">
        <div className="agenda-header">
          <div className="hora-col-header" />
          <div className="dia-header dia-header-diaria">
            {fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric' })}
          </div>
        </div>
        <div className="agenda-body">
          <div className="hora-col">
            {HORAS.map(h => <div key={h} className={`hora-label ${esHoy && h === ahora.getHours() ? 'hora-actual' : ''}`}>{h}:00</div>)}
          </div>
          <div className="dias-grid diaria">
            <div className="dia-col">
              {HORAS.map(h => <div key={h} className="celda-hora" onClick={() => onNuevaCita(fecha, h)} />)}
              {esHoy && topHoraActual >= 0 && topHoraActual <= (HORA_FIN - HORA_INICIO) * PX_HORA &&
                <div className="linea-hora-actual" style={{ top: topHoraActual, pointerEvents: 'none' }} />}
              {pintarCitasDia()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
